import { Controller } from "stimulus"

export default class extends Controller {
  toggle(event) {
    for(let checkbox of this.element.querySelectorAll('input[type=checkbox]')) {
      checkbox.checked = event.currentTarget.checked
    }
  }
}